import { fade } from '@material-ui/core/styles/colorManipulator';

export default theme => ({
  smallButtons: {
    padding: theme.spacing.unit,
    fontSize: 2 * theme.spacing.unit,
    color: fade(theme.palette.primary.dark, 0.75)
  }
});
